<app-dialog [size]="DialogSize.SMALL" type="confirmation">
  <app-dialog-header [showClose]="false" class="h1-600 text-center">
    All steps have been completed! Do you want to leave this page?
  </app-dialog-header>

  <p class="body-400 color-gray-400 text-center">
    Thank you for completing this request. You will be notified if further action is required.
  </p>

  <app-dialog-footer [showCancel]="false" [equalWidthButtons]="true">
    <button
      andButton
      size="large"
      [mat-dialog-close]="false"
      [dataSelector]="baseDataSelector + '-stay-button'"
    >
      Stay here
    </button>

    <button
      andButton
      size="large"
      color="primary"
      [mat-dialog-close]="true"
      class="ms-3"
      [dataSelector]="baseDataSelector + '-leave-button'"
    >
      Leave this page
    </button>
  </app-dialog-footer>
</app-dialog>